class FormErrorsSummaryController {
  constructor() { }
}

export default FormErrorsSummaryController;



// WEBPACK FOOTER //
// ./client/app/components/formErrorsSummary/formErrorsSummary.controller.js